export const COUNTRY_CODES = [
	{
		iso: 'sa',
		code: '+966'
	},
	{
		iso: 'ae',
		code: '+971'
	},
	{
		iso: 'bh',
		code: '+973'
	},
	{
		iso: 'kw',
		code: '+965'
	},
	{
		iso: 'om',
		code: '+968'
	},
	{
		iso: 'cn',
		code: '+86'
	},
	{
		iso: 'eg',
		code: '+20'
	},
	{
		iso: 'ma',
		code: '+212'
	},
	{
		iso: 'fr',
		code: '+33'
	},
	{
		iso: 'de',
		code: '+49'
	},
	{
		iso: 'gb',
		code: '+44'
	},
	{
		iso: 'gr',
		code: '+30'
	},
	{
		iso: 'in',
		code: '+91'
	},
	{
		iso: 'id',
		code: '+62'
	},
	{
		iso: 'jp',
		code: '+81'
	},
	{
		iso: 'jo',
		code: '+962'
	},
	{
		iso: 'ke',
		code: '+254'
	},
	{
		iso: 'my',
		code: '+60'
	},
	{
		iso: 'ph',
		code: '+63'
	},
	{
		iso: 'pl',
		code: '+48'
	},
	{
		iso: 'ru',
		code: '+7'
	},
	{
		iso: 'za',
		code: '+27'
	},
	{
		iso: 'ch',
		code: '+41'
	},
	{
		iso: 'tz',
		code: '+255'
	},
	{
		iso: 'tr',
		code: '+90'
	},
	{
		iso: 'us',
		code: '+1'
	}
];
